import { settings } from "../assets/settings";

export const Path = {
    root: {
        url: settings.root
    },
    facilities: {
        url: settings.root+"facilities",
        view: {
            url: settings.root+"facilities/:facilityId",
        }
    },
    map: {
        url: settings.root+"map"
    },
};

export class PathGenerator {
    static facility(facilityId){
        return Path.facilities.view.url.replace(/:facilityId/g, facilityId);
    }   
}

export const ExternalPath = {
    company: "https://www.sys.ne.jp/",
}